<template>
  <section :class="classes" :id="`uuid-${model.uuid}`" :ref="`id-${model.uuid}`">
    <div class="section__container">
      <div class="grid-x align-center motoplex--custom">
        <slot :sectionStyle="model.sectionStyle" :cell="'large-5'">

        </slot>
      </div>
    </div>
  </section>
</template>

<script>
  import { mgnlComponentMixin } from "@wl-vue-mixins/mixins.js";

  export default {
    mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
    name: "EditorialArea",
    data() {
      return {}
    },
    computed: {
      classes() {
        return [
          "section",
          this.model.sectionStyle ? "section--" + this.model.sectionStyle : ''
        ];
      }
    },
    methods: {
      scrollToAnchor(targetId) {

        if (targetId == `id-${this.model.uuid}`) {
          const anchor = this.$refs[targetId];

          if (!anchor) return;
          const marginToTop = 144;
          const bounding = anchor.getBoundingClientRect();
          let distanceToTop = Math.floor(bounding.top - marginToTop);

          if (window.pageYOffset === 0) {
            distanceToTop -= 62;
          }

          anchor.parentElement.tabIndex = -1;
          anchor.parentElement.focus();

          window.scrollBy({top: distanceToTop, left: 0, behavior: "smooth"});

        }
      },
    },
    mounted() {
      // Listen for message events
      this.$eventHub.on("anchor:scrollTo", (targetId) => {
        this.scrollToAnchor(targetId);
      });
    }
  };
</script>